// Function to update the price in the product-info__price div, including the original price markup
function updatePrice(newPriceHTML) {
    const priceContainer = document.querySelector('.product-info__price');
    const priceElement = document.querySelector('.product-info__price .price__current');

    if (priceElement) {
        priceElement.innerHTML = newPriceHTML; // Set the inner HTML instead of just the text content
        // Show the price field when the price is available
        priceContainer.style.display = 'block';
    }
}

// Function to hide the second price field on page load and show a message
function hidePriceField() {
    const priceContainer = document.querySelector('.product-info__price');
    if (priceContainer) {
        priceContainer.style.display = 'none';
    }

    // Show "Select a product to build your bundle" message if not already shown
    if (!document.querySelector('.bundle-message')) {
        const messageContainer = document.createElement('p');
        messageContainer.textContent = 'Select a product to build your bundle';
        messageContainer.classList.add('bundle-message');
        const parent = priceContainer.parentNode;
        if (parent) {
            parent.insertBefore(messageContainer, priceContainer);
        }
    }
}

// Function to remove the "Select a product" message
function removeSelectProductMessage() {
    const message = document.querySelector('.bundle-message');
    if (message) {
        message.remove();
    }
}

// Function to get the price from the new field, including the full HTML with tstrike class
function getBundlePrice() {
    const bundlePriceElement = document.querySelector('.thl-copy span[aria-label*="Actual price"]');
    if (bundlePriceElement) {
        return bundlePriceElement.innerHTML.trim(); // Copy the full HTML
    }
    return null;
}

// Function to initialize the price watcher
function initPriceWatcher() {
    // Hide the price field on page load
    hidePriceField();

    // Observe the body or a parent element that always exists
    const observerTarget = document.body;

    // Set up MutationObserver to watch for changes in the document body
    const config = { childList: true, subtree: true };

    let bundlePriceElement = null;
    let priceObserver = null;

    const mainCallback = function (mutationsList) {
        for (const mutation of mutationsList) {
            // Check if the price element is added or removed
            const currentBundlePriceElement = document.querySelector('.thl-copy span[aria-label*="Actual price"]');

            if (currentBundlePriceElement && currentBundlePriceElement !== bundlePriceElement) {
                // Price element added or changed
                bundlePriceElement = currentBundlePriceElement;
                const newPriceHTML = getBundlePrice();
                if (newPriceHTML) {
                    updatePrice(newPriceHTML);
                    removeSelectProductMessage();
                }

                // Set up observer on the price element
                if (priceObserver) {
                    priceObserver.disconnect();
                }
                priceObserver = new MutationObserver(priceCallback);
                priceObserver.observe(bundlePriceElement, { characterData: true, childList: true, subtree: true });

            } else if (!currentBundlePriceElement && bundlePriceElement) {
                // Price element removed
                bundlePriceElement = null;
                hidePriceField();
                if (priceObserver) {
                    priceObserver.disconnect();
                    priceObserver = null;
                }
            }
        }
    };

    const priceCallback = function (mutationsList) {
        for (const mutation of mutationsList) {
            const newPriceHTML = getBundlePrice();
            if (newPriceHTML) {
                updatePrice(newPriceHTML);
                removeSelectProductMessage();
            } else {
                hidePriceField();
            }
        }
    };

    const mainObserver = new MutationObserver(mainCallback);
    mainObserver.observe(observerTarget, config);

    // Initial check in case the price is already available
    const initialPriceHTML = getBundlePrice();
    if (initialPriceHTML) {
        updatePrice(initialPriceHTML);
        removeSelectProductMessage();

        bundlePriceElement = document.querySelector('.thl-copy span[aria-label*="Actual price"]');

        // Set up observer on the initial price element
        if (bundlePriceElement) {
            priceObserver = new MutationObserver(priceCallback);
            priceObserver.observe(bundlePriceElement, { characterData: true, childList: true, subtree: true });
        }
    }
}

// Run the watcher function when the page is loaded
window.addEventListener('DOMContentLoaded', initPriceWatcher);
